import { Container, Flex, Heading, Text } from '@radix-ui/themes'
import {IPoster} from '../../../core/types/services-types/poster-types'
import moment from 'moment'
import React from 'react'
import { ROUTES } from '../../../routes/constants'
import { Link } from 'react-router'

export interface PosterRenderProps {
    poster: IPoster
}


export default function PosterRender(props: PosterRenderProps) {
    const {poster} = props
    return (
      <Flex align={'end'} gap={'4'} justify={'between'} wrap={'wrap'}>
        <Flex wrap={'wrap'}>
        <Container className='max-w-[300px] w-[100%] h-[auto]'>
            <img src={poster.main_image} />
        </Container>
        <Flex className='p-5' direction={'column'} maxWidth={'500px'}>
            <Heading className='mb-3'>
                <Link to={`/poster/${poster.id}`}> 
                {poster.title}
                </Link>
            </Heading>
         
            <Container>
                {poster.text.substring(0, 200)}...<Link to={`/poster/${poster.id}`}>Смотреть больше</Link>
            </Container>
        </Flex>
        </Flex>
        <Flex align={'end'} justify={'end'}>
        <Text color='gray' weight={'regular'}>
            {moment(poster.createdAt).format("DD.MM.YYYY HH:mm")}
        </Text>
        </Flex>
      </Flex>
    )
}